import BaseDialogTitle from '@material-ui/core/DialogTitle'

const DialogTitle = BaseDialogTitle

export default DialogTitle
